export default __webpack_public_path__ + "static/media/VitaminD.7874f8d0.svg";